import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tokens } from 'ComponentLibrary'

export const PlaygroundToolPageContainer = styled(Stack)(() => ({
    gap: tokens.SizingSpacing300,
    padding: 0,
    backgroundColor: tokens.ColorBackgroundLight,
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
}))
